import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { isMobile } from '@icp/utils';
import {
  AUTH_SUCCESS_REDIRECT_URL_STORAGE_KEY,
  ssoLoginSuccessCallback,
} from 'store/features/authSlice';
import ErrorPage from './ErrorPage';

export default function SSOCallback2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [err, setErr] = useState(null);

  useEffect(() => {
    dispatch(ssoLoginSuccessCallback())
      .unwrap()
      .then(() => {
        const from = sessionStorage.getItem(AUTH_SUCCESS_REDIRECT_URL_STORAGE_KEY);
        sessionStorage.removeItem(AUTH_SUCCESS_REDIRECT_URL_STORAGE_KEY);

        if (from) {
          window.location.replace(from);
        } else if (isMobile()) {
          navigate('/mobile', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      })
      .catch(setErr);
  }, [dispatch, navigate]);

  if (err) return <ErrorPage status="error" subTitle={err.message} />;

  return null;
}
